/** A failed or stalled optional route must reach the existing route error boundary. */
export async function loadRouteModule<T>(load: () => Promise<{ default: T }>, timeoutMs = 20_000): Promise<{ default: T }> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    const module = await Promise.race([
      load(),
      new Promise<never>((_, reject) => {
        timer = setTimeout(() => reject(new Error("Het laden van dit scherm duurt te lang. Probeer opnieuw.")), timeoutMs);
      }),
    ]);
    if (!module || module.default == null) {
      throw new Error("Het scherm kon niet worden geladen: de paginamodule ontbreekt.");
    }
    return module;
  } finally {
    if (timer !== undefined) clearTimeout(timer);
  }
}
